import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import i18next from 'i18n/i18n';
import { YN_TYPE } from 'types/enumType';

export const permissionSchema = yupResolver(
  yup.object({
    factoryId: yup.string().required(i18next.t('validation.enterPlant')),
    equipName: yup.string().defined(i18next.t('validation.enterDevice')),
    name: yup.string().required(i18next.t('validation.enterOrder')),
    detail: yup.string().required(i18next.t('validation.enterWork')),
    workDate: yup.string().required(i18next.t('validation.enterDate')),
    lotoYn: yup.string().oneOf([YN_TYPE.Y, YN_TYPE.N]).required(i18next.t('validation.enterSetting')),
    selfWorkYn: yup.string().oneOf([YN_TYPE.Y, YN_TYPE.N]).required(i18next.t('validation.selectCoopWorkYn')),
    coopUserId: yup.number()
      .when('selfWorkYn', {
        is: (selfWorkYn: YN_TYPE) => selfWorkYn === YN_TYPE.N,
        then: schema => schema.required(i18next.t('validation.selectCoop'))
      }
      ),
    // coopWorker: yup.string()
    //   .when('selfWorkYn', {
    //     is: (selfWorkYn: YN_TYPE) => selfWorkYn === YN_TYPE.N,
    //     then: schema => schema.required(i18next.t('validation.enterWorkInfo'))
    //   }
    //   ),
    coopInfo: yup.string().optional()
  }),
);
